module.exports = __webpack_public_path__ + "static/img/MMF.564576ca.png";